var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7.9375mm",
    height: "10.583mm",
    viewBox: "0 0 7.9375 10.583333",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-156.29 -334.04)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 614.02 489.43)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-1730-587.31h30v40h-30z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.7843)",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    "aria-label": 6
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1731.9-578.97q0-0.95703 0.3646-1.8001 0.3646-0.86589 1.0026-1.4811 0.638-0.63802 1.4811-1.0026 0.8659-0.38737 1.8229-0.38737h14.925q0.957 0 1.8001 0.38737 0.8659 0.36458 1.5039 1.0026 0.638 0.61523 1.0026 1.4811 0.3646 0.8431 0.3646 1.8001v4.2155h-4.6712v-4.2155h-14.925v9.3424h14.925q0.957 0 1.8001 0.36458 0.8659 0.36458 1.5039 1.0026 0.638 0.63802 1.0026 1.5039 0.3646 0.8431 0.3646 1.8001v9.3197q0 0.95703-0.3646 1.8229-0.3646 0.8431-1.0026 1.4811t-1.5039 1.0026q-0.8431 0.36459-1.8001 0.36459h-14.925q-0.957 0-1.8229-0.36459-0.8431-0.36458-1.4811-1.0026t-1.0026-1.4811q-0.3646-0.86589-0.3646-1.8229zm4.6712 14.014v9.3197h14.925v-9.3197z",
    strokeWidth: "1px",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.c55604b5c6e688cbad56c8031f5ae61c.svg";
export { ForwardRef as ReactComponent };